import JikeLogo from '@/assets/jike-logo.svg?react'
import Bowser from 'bowser'
import { motion } from 'motion/react'
import Page, { type PageProps } from './Page'
import styles from './UnsupportedBrowserPage.module.css'

export interface UnsupportedBrowserPageProps extends PageProps {}

export default function UnsupportedBrowserPage({ ...props }: UnsupportedBrowserPageProps) {
	const browserInfo = Bowser.getParser(window.navigator.userAgent)
	const { name, version } = browserInfo.getBrowser()

	return (
		<Page {...props}>
			<div className={styles.container}>
				<JikeLogo className={styles.logo} />

				<h1 className={styles.h1}>请使用新版浏览器</h1>

				<p className={styles.p}>
					为获得最佳用户体验，推荐使用以下浏览器的最新版本
					<br />
					（当前浏览器：{name} v{version}）
				</p>

				<ul className={styles.ul}>
					<li>
						<motion.a
							href="https://www.apple.com/safari/"
							target="_blank"
							rel="noreferrer noopenner"
							whileTap={{
								scale: 0.98,
							}}
							className={styles.browserItem}
						>
							<img src="/safari.svg" />
							<span>v{import.meta.env.VITE_SUPPORTED_MIN_SAFARI_VERSION}+</span>
						</motion.a>
					</li>
					<li>
						<motion.a
							href="https://www.google.com/chrome/"
							target="_blank"
							rel="noreferrer noopenner"
							whileTap={{
								scale: 0.98,
							}}
							className={styles.browserItem}
						>
							<img src="/chrome.svg" />
							<span>v{import.meta.env.VITE_SUPPORTED_MIN_CHROME_VERSION}+</span>
						</motion.a>
					</li>
					<li>
						<motion.a
							href="https://download-chromium.appspot.com/"
							target="_blank"
							rel="noreferrer noopenner"
							whileTap={{
								scale: 0.98,
							}}
							className={styles.browserItem}
						>
							<img src="/chromium.svg" />
							<span>v{import.meta.env.VITE_SUPPORTED_MIN_CHROME_VERSION}+</span>
						</motion.a>
					</li>
					<li>
						<motion.a
							href="https://www.mozilla.org/en-US/firefox/new/"
							target="_blank"
							rel="noreferrer noopenner"
							whileTap={{
								scale: 0.98,
							}}
							className={styles.browserItem}
						>
							<img src="/firefox.svg" />
							<span>v{import.meta.env.VITE_SUPPORTED_MIN_FIREFOX_VERSION}+</span>
						</motion.a>
					</li>
					<li>
						<motion.a
							href="https://www.microsoft.com/en-us/edge/download"
							target="_blank"
							rel="noreferrer noopenner"
							whileTap={{
								scale: 0.98,
							}}
							className={styles.browserItem}
						>
							<img src="/edge.svg" />
							<span>v{import.meta.env.VITE_SUPPORTED_MIN_EDGE_VERSION}+</span>
						</motion.a>
					</li>
				</ul>
			</div>
		</Page>
	)
}
